var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Like"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/heart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9674 3.0459C13.4041 3.0459 12.005 3.80596 11.1326 4.97195C10.2603 3.80596 8.86108 3.0459 7.29778 3.0459C4.64622 3.0459 2.49561 5.20515 2.49561 7.87399C2.49561 8.90179 2.65971 9.85186 2.94473 10.7328C4.30938 15.0513 8.5156 17.6338 10.5971 18.342C10.8908 18.4457 11.3744 18.4457 11.6681 18.342C13.7496 17.6338 17.9558 15.0513 19.3205 10.7328C19.6055 9.85186 19.7696 8.90179 19.7696 7.87399C19.7696 5.20515 17.619 3.0459 14.9674 3.0459Z",
    fill: "#2FF77A"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.f191f8b14b3171288add3e63277810d7.svg";
export { ForwardRef as ReactComponent };